module.exports = __webpack_public_path__ + "static/monitoring-urls-cbb79441a886aa0ab67fea212cc6d5a8.png";